export const ON_ENTER_TEST_ROOM = 'ON_ENTER_TEST_ROOM';
export const ON_REFETCH_TEST_LIST = 'ON_REFETCH_TEST_LIST';
// 누군가의 테스트/설문 제출 신호(WS) — 역할별 최소 처리(교사=제출현황 부분갱신, 학생=본인만 재조회)
export const ON_TEST_SUBMITTED = 'ON_TEST_SUBMITTED';
export const SET_QUESTION_LIST = 'SET_QUESTION_LIST';
export const SET_ANSWER_LIST = 'SET_ANSWER_LIST';
export const SET_STATISCIS_LIST = 'SET_STATISCIS_LIST';
export const SET_SUBMIT_LIST = 'SET_SUBMIT_LIST';
export const SET_TEST_BACKGROUND = 'SET_TEST_BACKGROUND';
export const SET_TEST_LIST = 'SET_TEST_LIST';
export const CLOSE_TEST_MODAL = 'CLOSE_TEST_MODAL';
export const TOGGLE_TEST_MODAL = 'TOGGLE_TEST_MODAL';
export const TOGGLE_FOLD_MODAL = 'TOGGLE_FOLD_MODAL';
export const SET_FOCUS_TEST_ID = 'SET_FOCUS_TEST_ID';
export const SET_FOCUS_USER = 'SET_FOCUS_USER';
export const SET_NOT_SUBMIT_USER = 'SET_NOT_SUBMIT_USER';
export const SET_SURVEY_FREQUENCY = 'SET_SURVEY_FREQUENCY';
export const SET_SURVEY_SAVE = 'SET_SURVEY_SAVE';
export const SET_OMR_FREQUENCY = 'SET_OMR_FREQUENCY';
export const SET_TEST_TYPE = 'SET_TEST_TYPE';
// 모의고사 개별 타이머: 학생이 실제 문항/첨부파일을 처음 확인한 시점에 '시작됨'으로 표시.
export const SET_PERSONAL_TIMER_STARTED = 'SET_PERSONAL_TIMER_STARTED';
// 풀이시간 종료 감지(무제출 포함) — sessionStorage 마커(mock_timeup)와 달리 리렌더를 유발하는 redux 신호.
export const SET_TEST_TIME_UP = 'SET_TEST_TIME_UP';
// export const SET_SURVEY_DATA = 'SET_SURVEY_DATA';
